import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-dc442c76"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "users-wait" }
const _hoisted_2 = { class: "users-wait__container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MailIcon = _resolveComponent("MailIcon")!
  const _component_AHeading = _resolveComponent("AHeading")!
  const _component_ABody = _resolveComponent("ABody")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_MailIcon),
      _createVNode(_component_AHeading, {
        class: "users-wait__heading",
        level: 2
      }, {
        default: _withCtx(() => [
          _createTextVNode("確認メールを送信しました")
        ], undefined, true),
        _: 1
      }),
      _createVNode(_component_ABody, {
        class: "users-wait__body",
        size: "small"
      }, {
        default: _withCtx(() => [
          _createTextVNode(" 登録いただいたメールアドレスに確認メールを送信しています。 メールを確認いただき、添付されているURLからアカウント情報の入力に進んでください。 ")
        ], undefined, true),
        _: 1
      })
    ])
  ]))
}